import { directMenuMessages } from './directMenuRollout';

/** Existing Spanish settings surface copy, shared by delegated and operator views. */
export const settingsMessages = {
  title: 'Ajustes generales',
  scope: 'La delegación no permite administrar usuarios, permisos, métodos de pago ni el logo.',
  readOnly: 'Solo lectura. Un superadministrador debe habilitar la edición por separado.',
  loading: 'Cargando ajustes…',
  unavailable: 'No se pudieron confirmar los ajustes o el acceso.',
  conflict: 'Los ajustes cambiaron. Recarga antes de guardar.',
  reload: 'Recargar ajustes',
  save: 'Guardar ajustes',
  saved: 'Ajustes guardados.',
  noValue: 'Sin configurar',
  unknown: 'Valor no informado',
  print_orders: 'Imprimir órdenes',
  local_open: 'Local abierto',
  default_tip: 'Propina sugerida (%)',
  invalidTip: 'Indica una propina entre 0 y 100, con hasta dos decimales.',
  moneda_id: 'Moneda',
  language_id: 'Idioma',
  timezone_id: 'Zona horaria',
  main_caja_id: 'Caja principal',
  editors: 'Edición delegada de ajustes generales',
  editorScope: 'Solo usuarios activos del local con permiso 61 pueden recibir edición. Las autorizaciones anteriores también se muestran para poder revocarlas.',
  noEditors: 'No hay usuarios activos con el permiso de acceso.',
  allowEdit: 'Permitir edición',
};

export const delegatedSettingsMessages = {
  ...directMenuMessages,
  title: 'Acceso delegado a ajustes',
  description: 'Permite entrar a ajustes generales con el permiso 61. La edición se otorga por usuario y no permite administrar permisos.',
  enable: 'Habilitar acceso delegado a ajustes',
  empty: 'El acceso delegado está desactivado.',
  saved: 'Configuración de acceso delegado guardada.',
};
